import Vue from 'vue'

import axios from "axios";
export default class BlogVue {
    constructor() {
        new Vue({
            el: '#blog',
            data() {
                return {
                    base:window.location.href.includes("tecnologia") ? "/braslift/" : "/",
                    posts:[],
                    page:1,
                    pages:1,
                    per_page: 8,
                    category : null,
                    categories : [],
                }
            },
            async mounted() {
                this.categories = await this.getCategories();
                this.posts = await this.getPosts();
            },
            methods: {
                async getCategories() {
                    const data = await axios.get(this.base + "wp-json/wp/v2/categories");
                    return data.data;
                },
                async getPosts() {
                    let category = '';
                    if(this.category)
                        category = "&categories="+this.category;

                    const data = await axios.get(this.base + "wp-json/wp/v2/posts?per_page=8&page="+ this.page + category);
                    return data.data;
                }
            },
            watch: {
            }
        })
    }
}